import React, { FC } from "react";
import styles from "./Intro.module.css";
import ProfilePic from "../ProfilePic/ProfilePic";
import profilePic from "../../img/profile_pic.jpg";
import { Stack, Typography } from "@mui/material";

interface BadgeLink {
  img: string;
  link: string;
}
interface IntroProps {
  name: string;
  intro: string;
  badgeLinks: Record<string, BadgeLink>;
  updatedDate: Date;
}

/**
 * This function display how long ago the last update was made
 * @param date
 * @returns
 */
function displayLastUpdate(date: Date): string {
  const now = new Date();
  const diffTime = Math.abs(now.getTime() - date.getTime());
  const diffHours = diffTime / (1000 * 60 * 60);
  if (Math.ceil(diffHours) < 24) {
    if (diffHours < 1) {
      return "less than an hour ago";
    }
    return `${Math.ceil(diffHours)} hour${diffHours > 1 ? "s" : ""} ago`;
  }
  const diffDays = Math.ceil(diffHours / 24);
  if (diffDays < 30) {
    if (diffDays <= 1) return "yesterday";

    return `${diffDays} day${diffDays > 1 ? "s" : ""} ago`;
  }
  const diffMonths = Math.ceil(diffDays / 30);
  if (diffMonths < 12) {
    return `${diffMonths} month${diffMonths > 1 ? "s" : ""} ago`;
  }
  return date.toLocaleDateString("en-US", { year: "numeric", month: "numeric", day: "numeric" });
}

const Intro: FC<IntroProps> = (prop) => {
  const { name: profileName, intro: message, badgeLinks } = prop;
  return (
    <div className={`${styles.Intro} mx-auto`}>
      <ProfilePic picUrl={profilePic} />
      <Stack direction={"column"} spacing={2} alignItems={"center"}>
        <Typography fontSize={30} fontWeight={400}>{profileName}</Typography>
        <Stack direction={"row"} spacing={1} alignItems={"center"}>
          {Object.entries(badgeLinks).map(([key, val], index) => (
            <a href={val.link} key={index}>
              <img src={val.img} alt={`${key} badge`} />
            </a>
          ))}
          <small>Last Update: {displayLastUpdate(prop.updatedDate)}</small>
        </Stack>
        <Typography fontWeight={400}>{message}</Typography>
      </Stack>
    </div>
  );
};

export default Intro;
export type { IntroProps, BadgeLink };
